import { Badge, Col, ListGroupItem, Spinner } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SendIcon from "@mui/icons-material/Send";
import IconContainer from "../../organisms/IconContainer";
import AddIcon from "@mui/icons-material/Add";
import {
  EstadoReporteDiario,
  MascotaReporteDiario,
  QUERY_KEY_OBTENER_MASCOTAS_REPORTE_DIARIO,
  enviarReporteDiario,
  reporteFueCreado,
} from "../../../services/reporteDiarioServicios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function MascotaReporte({
  reporteDeMascota,
  onVerReporteClick,
  onCrearReporteClick,
  onEnviarError,
}: {
  reporteDeMascota: MascotaReporteDiario;
  onVerReporteClick: (reporteDeMascota: MascotaReporteDiario) => void;
  onCrearReporteClick: (reporteDeMascota: MascotaReporteDiario) => void;
  onEnviarError: () => void;
}) {
  const queryClient = useQueryClient();

  const enviarMutacion = useMutation(enviarReporteDiario, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_OBTENER_MASCOTAS_REPORTE_DIARIO],
      });
    },
    onError: onEnviarError,
  });

  const onClickVerReporte = () => {
    onVerReporteClick(reporteDeMascota);
  };

  const onClickCrearReporte = () => {
    onCrearReporteClick(reporteDeMascota);
  };

  const onEnviarReporteClick = (idAsistencia: string) => {
    enviarMutacion.mutate(idAsistencia);
  };

  const enviado = reporteDeMascota.estado === "REPORTE_ENVIADO";

  return (
    <ListGroupItem
      as="li"
      className={`d-flex mt-2 p-1 border rounded ${
        enviado ? "border-success" : ""
      }`}
    >
      <div className="ps-2 row w-100" style={{ paddingRight: 0 }}>
        <div className="row" style={{ paddingRight: 0 }}>
          <div className="col-4">
            <strong>{reporteDeMascota.nombreMascota}</strong>
          </div>
          <div className="col-8" style={{ paddingRight: 0 }}>
            <div
              className="row justify-content-end d-flex flex-row"
              style={{ paddingRight: 0 }}
            >
              {reporteFueCreado(reporteDeMascota) && (
                <Col xs={"auto"}>
                  <IconContainer
                    onClick={onClickVerReporte}
                    style={{ cursor: "pointer" }}
                  >
                    <VisibilityIcon />
                  </IconContainer>
                </Col>
              )}
              {reporteDeMascota.estado === "REPORTE_CREADO" && (
                <Col xs={"auto"}>
                  {enviarMutacion.isLoading && (
                    <Spinner animation="border" size="sm" />
                  )}
                  {!enviarMutacion.isLoading && (
                    <IconContainer
                      onClick={() => {
                        onEnviarReporteClick(reporteDeMascota.idAsistencia);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <SendIcon />
                    </IconContainer>
                  )}
                </Col>
              )}
              {reporteDeMascota.estado === "SIN_REPORTE" && (
                <Col xs={"auto"}>
                  <IconContainer
                    onClick={onClickCrearReporte}
                    style={{ cursor: "pointer" }}
                  >
                    <AddIcon />
                  </IconContainer>
                </Col>
              )}
              <Col xs={"auto"}>
                <BadgeEstado estado={reporteDeMascota.estado} />
              </Col>
            </div>
          </div>
        </div>

        <div className="row d-flex flex-row justify-content-start">
          <Col style={{ paddingRight: 0 }}>
            <small>{reporteDeMascota.nombrePropietario}</small>
          </Col>
        </div>
      </div>
    </ListGroupItem>
  );
}

const BadgeEstado = ({ estado }: { estado: EstadoReporteDiario }) => {
  if (estado === "SIN_REPORTE") {
    return <Badge bg="warning">Sin Reporte</Badge>;
  }
  if (estado === "REPORTE_CREADO") {
    return <Badge bg="primary">Creado</Badge>;
  }
  if (estado === "REPORTE_EN_ENVIO") {
    return <Badge bg="info">En envío</Badge>;
  }
  if (estado === "REPORTE_ENVIADO") {
    return <Badge bg="success">Enviado</Badge>;
  }
  if (estado === "ENVIO_FALLIDO") {
    return <Badge bg="danger">Envío Fallido</Badge>;
  }
  return <></>;
};

export default MascotaReporte;
